var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2891_49885)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.67696 5.06577L1.98723 6.51093L3.04482 7.01569L3.84884 5.33109V0.592766H2.67696V5.06577Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83854 8.8284V8.21938L6.33346 5.06578V0.592774H5.16159V5.33109L6.66667 8.48469V8.8284H7.83854Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84254 0.00683594H2.16786V1.17871H6.84254V0.00683594Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 8.8284H7.83854L7.83855 8.4847L9.34359 5.33107V0.592755H8.17172V5.06577L6.66668 8.2194L6.66667 8.8284Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 8.8284V8.21938L11.8283 5.06579V0.592774H10.6564V5.33109L12.1614 8.48468V8.8284H13.3333Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3373 0.00683594H7.66266V1.17871H12.3373V0.00683594Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1614 8.8284H13.3333L13.3333 8.4847L14.8384 5.33107V0.592755H13.6665V5.06576L12.1614 8.2194L12.1614 8.8284Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.323 5.06578L18.0128 6.51094L16.9552 7.0157L16.1512 5.3311V0.592773H17.323V5.06578Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8322 0.00683594H13.1575V1.17871H17.8322V0.00683594Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.0003H20V5.89869H18.2422C17.2714 5.89869 16.4844 6.68571 16.4844 7.6565V8.24244H3.51562V7.6565C3.51562 6.68571 2.7286 5.89869 1.75781 5.89869H0V20.0003ZM1.17187 18.8284V7.07057H1.75781C2.0814 7.07057 2.34375 7.33292 2.34375 7.6565V9.41432H17.6562V7.6565C17.6562 7.33292 17.9186 7.07057 18.2422 7.07057H18.8281V18.8284H1.17187Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8101 17.4629H10.1899L14.1278 15.291V13.2504L10.2083 10.7798H9.79185L5.87218 13.2508V15.291L9.8101 17.4629ZM10 16.2294L7.04406 14.599V13.8973L10.0001 12.0338L12.9559 13.897V14.599L10 16.2294Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2423 4.68776H8.75767V5.85963H11.2423V4.68776Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2423 2.34401H8.75767V3.51588H11.2423V2.34401Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7371 4.68776H14.2525V5.85963H16.7371V4.68776Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7371 2.34401H14.2525V3.51588H16.7371V2.34401Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78653 4.68776H3.30193V5.85963H5.78653V4.68776Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78653 2.34401H3.30193V3.51588H5.78653V2.34401Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2891_49885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.7eeb1746bbf84a2eb546b033972ef7e3.svg";
export { ForwardRef as ReactComponent };